import React from "react"
import {Box, Typography} from "@mui/material";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCOPicture from "../../fundamentals/CCOPicture";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {getKey} from "../../../utility/componentUtil";
import {usePreviewContext} from "../../../context/PreviewContext";
import dynamic from "next/dynamic";


export interface Props {
    gallery: any
    galleryHeadline?: string
    hideImageTitle?: boolean
    isRichText?: boolean
}

export function getContentClassName(id: string) {
    return `carousel-content-${id}`;
}

const CCOCarousel = dynamic(() => import('../../fundamentals/CCOCarousel'), {
    ssr: false
})


function C008ImageGalley(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const carouselContentClassName = getContentClassName(getKey(props?.gallery?.id));
    function prepareItems(collectionItems: Array<any>) {
        const preparedItems: Array<any> = [];
        collectionItems.map((item: any, index: number) => {
            preparedItems.push(renderItem(item, index));
        });
        return preparedItems;
    }

    function renderItem(item: any, index: number) {
        const copyrightMarginTop = item.detailText ? '-12px' : '4px';

        return <Box data-cypress={'imageGalleryItem'} key={`${index}-${item.id}`} width={'100%'} height={'100%'} className={carouselContentClassName}>
            <CCOPicture maxSize={true}
                        name={item.picture?.name}
                        key={`img-${index}`}
                        picture={item.picture}
                        orientation={"landscape_ratio16x9"}
                        width={"960"}
                        height={"540"}/>
            {item.detailText ? <CCORichText metadataId={item.id} key={`text-${index}`}
                                            variant={'subtitle2'}
                                            propertyName='properties.detailText'
                                            textAsTree={item.detailText.textAsTree}
                                            renderDownloadAsLink/> : null}
            {item.picture?.copyright ? <Typography variant={'subtitle2'} sx={{marginTop: copyrightMarginTop}}>&copy; {item.picture.copyright}</Typography> : null}
        </Box>
    }

    function renderHead(isRichText?: boolean) {
        const headlinePropertyName = isRichText ? 'properties.teaserTitle' : 'properties.headline';
        return <CCOHeadline metadataId={props.gallery.id} id={props.gallery.id}
                            headline={props.gallery.teaserTitle ?? props.galleryHeadline}
                            type={"componenthead"}
                            propertyName={headlinePropertyName}
                            subtext={props.gallery.teaserText?.textAsTree}
                            isRichText={isRichText}
                            subtextPropertyName='properties.teaserText' />
    }

    function renderGallery() {
        return <React.Fragment>
            {props.gallery.items ?
                props.gallery.items.length > 1 ?
                    <CCOCarousel key={'carousel'}
                                 autoPlay={false}
                                 items={prepareItems(props.gallery.items)}
                                 paginateItems={false}
                                 contentClassName={carouselContentClassName}
                    /> : renderItem(props.gallery.items[0], 0)
                : null
            }
        </React.Fragment>
    }

    if (props.isRichText) {
        return <>
            {renderHead(true)}
            {renderGallery()}
        </>
    }

    return <CCOComponentWrapper>
        {renderHead()}
        <CCOContainer>
            {renderGallery()}
        </CCOContainer>
    </CCOComponentWrapper>
}

export default C008ImageGalley


